import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Input, Section } from '../Shared';
import { OtherSourceType, citingOptions } from '../../forms/online-database/constants';
import { PubMainTypeEnum, PubSuffixTypeEnum, SourceType } from '../../types';
import { CITING_SECTION_TITLE } from './constants';
import { ArticlePublishedByDatabaseDropdown } from '../../forms/online-database/constants/fieldList/styled';

/** online-database citing section id and testId */
export var SECTION_ID = 'online-database-what-im-citing';
export var SECTION_TEST_ID = "".concat(SECTION_ID, "-test");

/** other constants */
export var ONLINE_DATABASE_DROPDOWN_TEST_ID = 'online-database-dropdown-test';
export var ONLINE_DATABASE_TITLE_TEST_ID = 'online-database-title-test';
export var ONLINE_DATABASE_DROP_HELPER_TEXT = 'Choose the type of source found in the database';
export var OnlineDatabaseCitingSection = function OnlineDatabaseCitingSection(_ref) {
  var onSourceChange = _ref.onSourceChange;
  var getPubTypeMain = function getPubTypeMain(source) {
    switch (source) {
      case SourceType.JOURNAL:
      case SourceType.DISSERTATION_ABSTRACT:
        return PubMainTypeEnum.PUB_JOURNAL;
      case SourceType.FILM_ONLINE_VIDEO:
        return PubMainTypeEnum.PUB_FILM;
      case SourceType.MAGAZINE:
        return PubMainTypeEnum.PUB_MAGAZINE;
      case SourceType.NEWSPAPER:
        return PubMainTypeEnum.PUB_NEWSPAPER;
      case SourceType.LECTURE:
        return PubMainTypeEnum.PUB_LIVE;
      case SourceType.NEWSLETTER:
      case SourceType.MUSICAL_RECORDING:
        return PubMainTypeEnum.PUB_NONE;
      default:
        return PubMainTypeEnum.PUB_NONPERIODICAL;
    }
  };
  var handleCitationOptionChange = function handleCitationOptionChange(_ref2) {
    var value = _ref2.value;
    if (Object.values(OtherSourceType).includes(value)) {
      setcurrentDropdownValue(value);
    } else {
      if (onSourceChange && value !== SourceType.ONLINE_DATABASE) {
        onSourceChange(value, {
          main: getPubTypeMain(value),
          suffix: PubSuffixTypeEnum.PUB_DATABASE
        });
      } else setcurrentDropdownValue(SourceType.ONLINE_DATABASE);
    }
  };
  var _useState = useState(citingOptions[0].value),
    _useState2 = _slicedToArray(_useState, 2),
    currentDropdownValue = _useState2[0],
    setcurrentDropdownValue = _useState2[1];
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: SECTION_ID + '-label',
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(ArticlePublishedByDatabaseDropdown, {
    inputId: "source",
    options: citingOptions,
    value: currentDropdownValue,
    labelText: 'Source type',
    "data-test": ONLINE_DATABASE_DROPDOWN_TEST_ID,
    helperText: ONLINE_DATABASE_DROP_HELPER_TEXT,
    onSelectValue: function onSelectValue(selectedOption) {
      return handleCitationOptionChange({
        value: selectedOption
      });
    }
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "database.title",
    "data-test": ONLINE_DATABASE_TITLE_TEST_ID,
    labelText: 'Article title'
  }));
};